import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReviewHistory30Cfu from "./ReviewHistory30Cfu";
import ReviewHistoryEnglish from "./ReviewHistoryEnglish";
import { REVISOR_CONTEXTS } from "const";

class ReviewHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idUser: this.props.match.params.idUser || 0,
    };
  }

  //--- ---

  render() {
    const { idUser } = this.state;
    const { context } = this.props.match.params;

    return (
      <>
        {[
          REVISOR_CONTEXTS.ABILITAZIONE30,
          REVISOR_CONTEXTS.ABILITAZIONE60,
          REVISOR_CONTEXTS.ART13,
          REVISOR_CONTEXTS.TFAINDIRE,
        ].includes(context) && (
          <ReviewHistory30Cfu idUserRevisor={idUser} context={context} />
        )}
        {context === REVISOR_CONTEXTS.ENGLISH && (
          <ReviewHistoryEnglish idUserRevisor={idUser} context={context} />
        )}
      </>
    );
  }
}

export default withRouter(ReviewHistory);
